import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { authApi } from "../lib/auth";
import { errMsg } from "../lib/api";

export const AuthCallback = () => {
  const location = useLocation();
  const nav = useNavigate();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(location.hash.slice(1)).get("session_id");
    authApi
      .post("/auth/session", { session_id: sid })
      .then((r) => nav("/admin", { replace: true, state: { user: r.data } }))
      .catch((e) => nav("/admin", { replace: true, state: { error: errMsg(e) } }));
  }, [location.hash, nav]);

  return (
    <main className="min-h-screen grid place-items-center" data-testid="auth-callback">
      <p className="font-mono-x">Signing you in...</p>
    </main>
  );
};
